import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: inline-flex;
  font-family: 'Noto Sans', sans-serif;
  flex-direction: column;
  min-width: 250px;
  max-width: 650px;
  position: relative;
`;
Container.displayName = 'Container';

export const Frame = styled.div`
  position: absolute;
`;
Frame.displayName = 'Frame';

export const FrameContainer = styled.div`
  align-items: center;
  display: flex;
  height: 554px;
  justify-content: center;
  position: relative;
  width: 555px;
`;
FrameContainer.displayName = 'FrameContainer';

export const Time = styled.div`
  color: #ffffff;
  font-size: 82px;
  font-weight: 500;
  letter-spacing: 1px;
  position: relative;
  text-align: center;
  top: -5px;
`;
Time.displayName = 'Time';

export const Title = styled.div`
  color: #fe1817;
  font-weight: 600;
  font-size: 36px;
  letter-spacing: 1px;
  margin-bottom: 10px;
  position: relative;
  text-align: center;
  top: -65px;
  white-space: pre-wrap;
`;
Title.displayName = 'Title';
